import { useId } from 'react';

import Icon from 'ms-ui-primitives/Icon';

import type { Props } from '../types';

const Customise = ({
  color,
  size,
  title,
  titleId,
  aphroditeStyles = [],
}: Props) => {
  const mask1Id = useId();
  const mask2Id = useId();
  return (
    <Icon
      color={color}
      size={size}
      aphroditeStyles={aphroditeStyles}
      title={title}
      titleId={titleId}
      viewBoxWidth={24}
      viewBoxHeight={24}
    >
      <mask
        id={mask2Id}
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="2"
        y="3"
        width="20"
        height="18"
      >
        <mask
          id={mask1Id}
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="24"
        >
          <path fill="#D9D9D9" d="M0 0h24v24H0z" />
        </mask>
        <g mask={`url(#${mask1Id})`}>
          <path
            d="M17.75 20.25c-1.05 0-1.938-.363-2.662-1.087C14.363 18.437 14 17.55 14 16.5c0-1.05.363-1.938 1.088-2.662.725-.725 1.612-1.088 2.662-1.088 1.05 0 1.938.363 2.663 1.088.724.725 1.087 1.612 1.087 2.662 0 1.05-.363 1.938-1.087 2.663-.726.724-1.613 1.087-2.663 1.087Zm0-2c.483 0 .896-.17 1.238-.512.341-.342.512-.755.512-1.238s-.17-.896-.512-1.238a1.686 1.686 0 0 0-1.238-.512c-.483 0-.896.17-1.238.512A1.686 1.686 0 0 0 16 16.5c0 .483.17.896.512 1.238.342.341.755.512 1.238.512ZM11 17.5H5a.967.967 0 0 1-.713-.288A.968.968 0 0 1 4 16.5c0-.283.096-.52.287-.713A.967.967 0 0 1 5 15.5h6c.283 0 .52.096.713.287.191.192.287.43.287.713s-.096.52-.287.712A.968.968 0 0 1 11 17.5Zm-4.75-6.25c-1.05 0-1.938-.363-2.663-1.088C2.862 9.438 2.5 8.55 2.5 7.5c0-1.05.362-1.938 1.087-2.662C4.313 4.112 5.2 3.75 6.25 3.75c1.05 0 1.938.362 2.662 1.088C9.637 5.562 10 6.45 10 7.5c0 1.05-.363 1.938-1.088 2.662-.725.725-1.612 1.088-2.662 1.088Zm0-2c.483 0 .896-.17 1.237-.512C7.83 8.396 8 7.983 8 7.5s-.17-.896-.513-1.237A1.686 1.686 0 0 0 6.25 5.75c-.483 0-.896.17-1.237.513A1.686 1.686 0 0 0 4.5 7.5c0 .483.17.896.513 1.238.341.341.754.512 1.237.512ZM19 8.5h-6a.968.968 0 0 1-.713-.287A.967.967 0 0 1 12 7.5c0-.283.096-.52.287-.713A.968.968 0 0 1 13 6.5h6c.283 0 .52.096.712.287.192.192.288.43.288.713s-.096.52-.288.713A.968.968 0 0 1 19 8.5Z"
            fill="#1C1B1F"
          />
        </g>
      </mask>
      <g mask={`url(#${mask2Id})`}>
        <path d="M0 0h24v24H0z" />
      </g>
    </Icon>
  );
};

Customise.displayName = 'Customise';

export default Customise;
